import * as React from 'react'
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  Icon,
  IconButton,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'i18n'

type Props = {
  onClose?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onChange?: Function
  checked?: boolean
  checkbox?: boolean
  copyright: {
    songTitle: string
    artistName: string
    songCode: string
  }
}

const Component: React.FC<Props> = ({
  copyright,
  onClose,
  checkbox,
  checked: defaultChecked = false,
  onChange,
}) => {
  const s = useStyle({})
  const [checked, setChecked] = React.useState(defaultChecked)

  const onClick = () => {
    setChecked(!checked)
    onChange(copyright, !checked)
  }

  const { t } = useTranslation('components')

  return (
    <Card className={s.card}>
      {checkbox && <CardActions>{checked && <Icon>check</Icon>}</CardActions>}
      <CardContent className={s.content} onClick={checkbox && onClick}>
        <Typography variant="h5">{copyright.songTitle}</Typography>
        <div>
          {t('Card.Copyright.artist')}: {copyright.artistName}
        </div>
      </CardContent>
      {onClose && (
        <CardActions>
          <IconButton onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        </CardActions>
      )}
    </Card>
  )
}

export default Component

const useStyle = makeStyles({
  card: {
    display: 'flex',
  },
  content: {
    flex: '1 1 auto',
  },
})
